import { makeStyles, Theme } from '@material-ui/core';
type StyleProps = {
  isCAS: boolean;
};

export const useUsersTableStyles = makeStyles<Theme, StyleProps>(() => ({
  table: (props) => ({
    '& .MuiTableRow-root': {
      '& > *:nth-child(2), *:nth-child(3)': {
        maxWidth: '256px',
        '& p': {
          maxWidth: '100%',
          whiteSpace: 'nowrap',
          textOverflow: 'ellipsis',
          overflow: 'hidden',
          '&::after': {
            content: '""',
            display: 'block',
          },
        },
      },
      '& > *:nth-child(4), *:nth-child(5)': {
        maxWidth: props.isCAS && '256px',
        '& p': {
          maxWidth: props.isCAS && '100%',
          whiteSpace: props.isCAS ? 'nowrap' : 'normal',
          textOverflow: props.isCAS ? 'ellipsis' : 'normal',
          overflow: props.isCAS ? 'hidden' : 'normal',
        },
      },
    },
    marginBottom: 0,
  }),
}));
